"use client";

/* global gdAlertify */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable";
import { formatMoney } from "../utils/utils";
import DetalleTurnos from "./DetalleTurnos";
import ResumenPagoAuxiliar from "./honorarios/components/ResumenPagoAuxiliar";
import CalendarioDetalleAuxiliar from "./honorarios/components/CalendarioDetalleAuxiliar";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { BANCOS } from "../utils/bankData";

const Honorarios = () => {
    const navigate = useNavigate();
    const [mes, setMes] = useState("");
    const [resultados, setResultados] = useState([]);

    const [modalVisible, setModalVisible] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [showDetalle, setShowDetalle] = useState(false);
    const [detalleAuxID, setDetalleAuxID] = useState(null);
    const [adelantoAuxID, setAdelantoAuxID] = useState(null);

    // NUEVO: modal calendario detalle
    const [showCalendario, setShowCalendario] = useState(false);
    const [calendarioAuxID, setCalendarioAuxID] = useState(null);

    // Resumen Pago
    const [showResumen, setShowResumen] = useState(false);
    const [selectedResumenRow, setSelectedResumenRow] = useState(null);

    // NUEVO: modal notas siguiente periodo
    const [modalNotasVisible, setModalNotasVisible] = useState(false);
    const [selectedRowNotas, setSelectedRowNotas] = useState(null);

    // NUEVO: estado de liquidación de periodo
    const [periodoStatus, setPeriodoStatus] = useState({
        estado_adelanto: 'pendiente',
        estado_fm: 'pendiente'
    });

    // NUEVO: textos dinámicos para resumen
    const [configTextos, setConfigTextos] = useState(null);

    useEffect(() => {
        fetchConfigTextos();
    }, []);

    const fetchConfigTextos = async () => {
        try {
            const { data } = await axiosInstance.get("/configuracion/honorarios/resumen-textos");
            setConfigTextos(data.data);
        } catch (error) {
            console.error("Error al cargar textos de resumen", error);
        }
    };

    const handleCopiarImagen = async () => {
        const element = document.getElementById("resumen-pago-container-fm");
        if (!element) return;
        try {
            const canvas = await html2canvas(element, { scale: 2, backgroundColor: "#ffffff" });
            canvas.toBlob((blob) => {
                if (blob) {
                    navigator.clipboard.write([new ClipboardItem({ "image/png": blob })])
                        .then(() => alert("Imagen copiada al portapapeles."))
                        .catch(err => console.error("Error al copiar:", err));
                }
            });
        } catch (error) {
            console.error("Error imagen:", error);
        }
    };

    const abrirModal = (row) => {
        setSelectedRow(row);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setSelectedRow(null);
        setModalVisible(false);
    };

    // opcional: para recargar datos tras guardar
    const onConfirmMovimiento = () => {
        buscarCobranza(); // o setResultados([...]) si editas localmente
    };

    const buscarCobranza = async () => {
        if (!mes) return;
        // mes viene en formato "YYYY-MM"
        const [anio, mesNum] = mes.split("-");
        const anioInt = parseInt(anio, 10);

        // Determine SII retention multiplier based on year
        // Hasta 2025: 14.5% (0.855) | Desde 2026: 15.25% (0.8475)
        let retenMultiplier = 0.855;
        if (anioInt >= 2026) {
            retenMultiplier = 0.8475; // 15.25% retention
        }
        setRetencionSii(retenMultiplier);
        try {
            gdAlertify.showLoader();
            const params = { fecha: mes };
            // Ajusta la ruta si tu endpoint es diferente
            const response = await axiosInstance.get("/acuerdo-mutuo/new-remuneraciones", { params });
            // Suponemos que tu wrapper deja el array en response.data.data
            setResultados(response.data.data);
            
            if (response.data.periodo_status) {
                setPeriodoStatus(response.data.periodo_status);
            }
        } catch (error) {
            console.error("Error al buscar remuneraciones:", error);
        } finally {
            gdAlertify.hideLoader();
        }
    };

    // const columns = [
    //     { title: "Auxiliar", name: "auxiliar" },
    //     { title: "Cantidad Turnos", name: "cantidad_turnos" },
    //     {
    //         title: "Total Turno",
    //         name: "total_turno",
    //         render: row => `$${formatMoney(row.total_turno)}`
    //     },
    //     {
    //         title: "Total Movilización",
    //         name: "total_movilizacion",
    //         render: row => `$${formatMoney(row.total_movilizacion)}`
    //     },
    //     {
    //         title: "Total Colación",
    //         name: "total_colacion",
    //         render: row => `$${formatMoney(row.total_colacion)}`
    //     },
    //     {
    //         title: "Total Final",
    //         name: "total_final",
    //         render: row => `$${formatMoney(row.total_final)}`
    //     },
    // ];
    const [retencionSii, setRetencionSii] = useState(0.855);

    // ----- Helpers de acciones -----

    const construirResumenFinMes = (row) => {
        const brutoTurnosFM = (row.valor_turnos_total || 0) - (row.valor_turnos_adelanto || 0);
        const horasExtrasFM = (row.horas_extras_total || 0) - (row.horas_extras_adelanto || 0);
        const movilizacionFM = (row.locomocion_total || 0) - (row.locomocion_adelanto || 0);
        const colacionFM = (row.colacion_total || 0) - (row.colacion_adelanto || 0);
        const prestamosFM = row.prestamos_fm || 0;
        const otrosSumaFM = row.otros_suma_fm || 0;
        const otrosRestaFM = row.otros_resta_fm || 0;
        const vacacionesFM = row.vacaciones_fm || 0;

        const cantidadTurnosFM = (row.cantidad_turnos_total || 0) - (row.cantidad_turnos_adelanto || 0);

        const liquidoFM =
            (brutoTurnosFM + horasExtrasFM) * retencionSii +
            movilizacionFM +
            colacionFM +
            otrosSumaFM -
            otrosRestaFM +
            vacacionesFM -
            prestamosFM;

        const nombreCompleto = `${row.nombre_auxiliar || ""} ${row.apepat_auxiliar || ""} ${row.apemat_auxiliar || ""}`.trim();

        const linea = (label, value) =>
            value !== 0 ? `- ${label}: $${formatMoney(value)}` : "";

        let msg = `Hola ${nombreCompleto || "auxiliar"}, este es el resumen de tu pago de fin de mes del periodo ${mes || ""}:\\n\\n`;

        if (cantidadTurnosFM > 0) {
            msg += `Realizaste *${cantidadTurnosFM} turno(s)* en la segunda quincena.\\n\\n`;
        }

        msg += [
            linea("Turnos bruto FM", brutoTurnosFM),
            linea("Horas extras bruto FM", horasExtrasFM),
            linea("Movilización FM", movilizacionFM),
            linea("Alimentación FM", colacionFM),
            linea("Vacaciones FM", vacacionesFM),
            linea("Préstamos FM (descuento)", prestamosFM),
            linea("Otros suma FM", otrosSumaFM),
            linea("Otros resta FM", otrosRestaFM),
        ]
            .filter(Boolean)
            .join("\\n");

        msg += `\\n\\n*Líquido aproximado fin de mes:* $${formatMoney(liquidoFM)}\\n\\n`;
        msg += `Por favor revisa el detalle y confirma si está correcto.`;

        return msg;
    };

    const handleEnviarWhatsapp = (row) => {
        if (!row.fono_auxiliar) {
            alert("Este auxiliar no tiene teléfono registrado para WhatsApp.");
            return;
        }

        let telefono = String(row.fono_auxiliar).replace(/\\D/g, "");

        if (telefono.startsWith("569")) {
        } else if (telefono.startsWith("9")) {
            telefono = `569${telefono.slice(1)}`;
        } else if (telefono.length === 8) {
            telefono = `569${telefono}`;
        } else {
            telefono = `56${telefono}`;
        }

        const mensaje = construirResumenFinMes(row);
        const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
        window.open(url, "_blank");
    };

    const handleEnviarMail = () => {
        alert("Funcionalidad de envío de correo aún no implementada.");
    };

    // NUEVO — Abrir modal de notas siguiente periodo
    const handleNotasSiguientePeriodo = (row) => {
        setSelectedRowNotas(row);
        setModalNotasVisible(true);
    };

    // NUEVO — Guardar nota siguiente periodo
    const guardarNotaSiguientePeriodo = async (nota) => {
        console.log("Guardando nota del siguiente periodo para:", selectedRowNotas?.auxiliar_id, nota);

        // Aquí puedes implementar POST a tu API

        setModalNotasVisible(false);
        buscarCobranza();
    };

    // --- Helpers de cálculo y exportación ---

    const calcularTotalAPagar = (row) => {
        const turnosAdelanto = parseFloat(row.valor_turnos_adelanto || 0);
        const extrasAdelanto = parseFloat(row.horas_extras_adelanto || 0);
        const movAdelanto = parseFloat(row.locomocion_adelanto || 0);
        const colAdelanto = parseFloat(row.colacion_adelanto || 0);

        const liquidoAnticipo = ((turnosAdelanto + extrasAdelanto) * retencionSii) + movAdelanto + colAdelanto;

        const turnosTotal = parseFloat(row.valor_turnos_total || 0);
        const extrasTotal = parseFloat(row.horas_extras_total || 0);
        const movTotal = parseFloat(row.locomocion_total || 0);
        const colTotal = parseFloat(row.colacion_total || 0);

        const liquidoTotalMes = (turnosTotal + extrasTotal) * retencionSii + movTotal + colTotal - liquidoAnticipo;

        const prestamoFM = parseFloat(row.prestamos_fm || 0);
        const otrosSumaFM = parseFloat(row.otros_suma_fm || 0);
        const otrosRestaFM = parseFloat(row.otros_resta_fm || 0);
        const vacacionesFM = parseFloat(row.vacaciones_fm || 0);

        return liquidoTotalMes - prestamoFM + otrosSumaFM - otrosRestaFM + vacacionesFM;
    };

    const handleExportarNominaPago = () => {
        if (!resultados.length) {
            alert("No hay datos para exportar");
            return;
        }

        const dataToExport = resultados.map(row => {
            const totalAPagar = Math.round(calcularTotalAPagar(row));

            // 1. Filtrar montos <= 0
            if (totalAPagar <= 0) return null;

            // Funciones de limpieza
            const cleanText = (str) => {
                if (!str) return "";
                return str
                    .toString()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "") // Eliminar acentos
                    .replace(/[^a-zA-Z0-9 ]/g, "")   // Dejar solo letras, números y espacios
                    .trim();
            };

            const cleanAccount = (str) => {
                if (!str) return "";
                return str.toString().replace(/\D/g, ""); // Solo números
            };

            // Parse RUT del beneficiario (usar rut_pago del backend)
            let rutBody = "";
            let rutDv = "";
            const rutBeneficiario = row.rut_pago || row.rut; // Priorizar rut_pago, fallback a rut
            if (rutBeneficiario) {
                const cleanRut = rutBeneficiario.replace(/\./g, "").replace(/-/g, "");
                rutBody = cleanRut.slice(0, -1);
                rutDv = cleanRut.slice(-1);
            }

            // Usar datos estructurados del backend
            const nombrePago = row.nombre_pago || "";
            const banco = row.banco || "";
            const tipoCuentaBancaria = row.tipo_cuenta_bancaria || "";
            
            // Limpiar número de cuenta (SOLO NÚMEROS)
            const numeroCuenta = cleanAccount(row.numero_cuenta || "");

            // Buscar código de banco por nombre
            let codigoBanco = "";
            if (banco) {
                const bancoUpper = banco.toUpperCase();
                let bancoFound = BANCOS.find(b => bancoUpper.includes(b.nombre.toUpperCase()));

                // Heurística mejorada para códigos de banco
                if (!bancoFound) {
                    const getCodigoBanco = (text) => {
                        if (!text) return "";
                        if (text.includes("CHILE") || text.includes("EDWARDS")) return "001";
                        if (text.includes("ESTADO") || text.includes("CUENTA RUT") || text.includes("CUENTARUT")) return "012";
                        if (text.includes("SANTANDER")) return "037";
                        if (text.includes("BCI") || text.includes("CREDITO") || text.includes("CRÉDITO") || text.includes("MACH")) return "016";
                        if (text.includes("BICE")) return "028";
                        if (text.includes("FALABELLA")) return "051";
                        if (text.includes("ITAU") || text.includes("ITAÚ")) return "039";
                        if (text.includes("SCOTIA") || text.includes("SCOTIABANK")) return "014";
                        if (text.includes("RIPLEY") || text.includes("CHEK")) return "053";
                        if (text.includes("SECURITY")) return "049";
                        if (text.includes("CONSORCIO")) return "055";
                        if (text.includes("INTERNACIONAL")) return "009";
                        if (text.includes("HSBC")) return "031";
                        if (text.includes("COOPEUCH")) return "672";
                        if (text.includes("TENPO")) return "730";
                        if (text.includes("MERCADO") || text.includes("MERCADOPAGO")) return "875";
                        if (text.includes("HEROES") || text.includes("HÉROES")) return "729";
                        if (text.includes("TAPP") || text.includes("ANDES")) return "732";
                        if (text.includes("COPEC")) return "741";
                        if (text.includes("PARIS")) return "057";
                        if (text.includes("POLAR")) return "697";
                        if (text.includes("BRASIL")) return "017";
                        if (text.includes("BBVA")) return "504";
                        return "";
                    };
                    const codigoMejorado = getCodigoBanco(bancoUpper);
                    if (codigoMejorado) {
                        bancoFound = { codigo: codigoMejorado };
                    }
                }

                if (bancoFound) codigoBanco = bancoFound.codigo;
            }

            // Determinar medio de pago según tipo de cuenta y banco
            let medioPago = 7; // Valor por defecto: Abono Cta Corriente de Otro Banco (Cód. 7)

            const esVistaOAhorro = tipoCuentaBancaria && (
                tipoCuentaBancaria.toUpperCase().includes("VISTA") ||
                tipoCuentaBancaria.toUpperCase().includes("RUT") ||
                tipoCuentaBancaria.toUpperCase().includes("AHORRO")
            );

            if (codigoBanco === "001") {
                // Banco de Chile
                // El usuario solicita que VISTA sea 1, no 6.
                const esVista = tipoCuentaBancaria && tipoCuentaBancaria.toUpperCase().includes("VISTA");
                if (esVistaOAhorro && !esVista) {
                    medioPago = 6; // Abono Cta Ahorro Banco de Chile 
                } else {
                    medioPago = 1; // Abono CC / VISTA Banco Chile
                }
            } else {
                // Otros Bancos (incluido Banco Estado)
                // El usuario solicitó específicamente el código 7 para Banco Estado.
                // Según tabla estándar: 7 es Cta Corriente Otro Banco, 8 es Cta Ahorro Otro Banco.
                // Se mantiene 7 para todo "Otro Banco" según instrucción.
                medioPago = 7;
            }

            // Nombre del beneficiario (para la cuenta bancaria) - LIMPIO
            const rawNombreBeneficiario = nombrePago || `${row.nombre_auxiliar || ""} ${row.apepat_auxiliar || ""} ${row.apemat_auxiliar || ""}`;
            const nombreBeneficiario = cleanText(rawNombreBeneficiario);

            // Nombre del auxiliar (para la descripción del pago) - LIMPIO (usamos cleanText para descripción también)
            const rawNombreAuxiliar = `${row.nombre_auxiliar || ""} ${row.apepat_auxiliar || ""} ${row.apemat_auxiliar || ""}`;
            const nombreAuxiliarClean = cleanText(rawNombreAuxiliar);

            // Preparar descripción y mensaje LIMPIOS
            // "Pago [Nombre] [Mes] FM" -> mes formato YYYY-MM tiene guion, cleanText lo quitará (2025-01 -> 202501)
            // Si quieres mantener el guión en la fecha, habría que ajustar la regex, pero la instrucción fue "solo numeros y letras"
            const descripcionPago = cleanText(`Pago ${nombreAuxiliarClean} ${mes} FM`);
            const mensajePago = cleanText(`Periodo ${mes}`);

            // 2. Generar alertas de validación
            const alertas = [];
            if (!codigoBanco && medioPago !== 2 && medioPago !== 12 && medioPago !== 4) alertas.push("FALTA BANCO");
            if (!numeroCuenta && medioPago !== 2 && medioPago !== 12 && medioPago !== 4) alertas.push("FALTA CUENTA");
            if (!rutBody) alertas.push("DATO RUT");

            const alertaStr = alertas.length > 0 ? `REVISAR: ${alertas.join(", ")}` : "";

            return {
                "ALERTA DATOS": alertaStr, // Columna de advertencia al inicio
                "MEDIO DE PAGO*": medioPago,
                "RUT BENEFICIARIO*": rutBody,
                "DÍGITO VERIFICADOR RUT BENEFICIARIO*": rutDv,
                "NOMBRE BENEFICIARIO*": nombreBeneficiario.slice(0, 60),
                "CÓDIGO BANCO*": codigoBanco,
                "NÚMERO CUENTA*": numeroCuenta,
                "MONTO PAGO*": totalAPagar,
                "DESCRIPCIÓN PAGO": descripcionPago.slice(0, 119), // Max 119 chars según imagen
                "MAIL DE DESTINO PARA AVISO": row.email || row.email_auxiliar || "",
                "MENSAJE": mensajePago.slice(0, 256) // Max 256 chars según imagen
            };
        }).filter(Boolean); // Filtrar los nulos (montos <= 0)

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);

        // Estilos para filas con alertas
        // Nota: SheetJS Community Edition no exporta estilos visuales a archivo, pero dejamos la lógica lista
        // por si se usa una versión Pro o polyfill.
        // Simularemos marcando la primera celda con un carácter especial si hay alerta
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let R = range.s.r + 1; R <= range.e.r; ++R) {
            // Asumimos que columna A (índice 0) es ALERTA DATOS
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: 0 });
            const cell = worksheet[cellAddress];

            if (cell && cell.v && cell.v.toString().startsWith("REVISAR")) {
                // Iterar sobre todas las columnas de esa fila para "marcar"
                // Desafortunadamente, sin la versión PRO de SheetJS, no podemos poner background amarillo real.
                // Como alternativa, podemos poner "!!!" al inicio del texto de alerta para que destaque más.
                cell.v = "⚠️ " + cell.v;
            }
        }

        // Ajustar anchos de columna automáticamente
        const cols = Object.keys(dataToExport[0] || {}).map(key => ({ wch: key.length + 8 }));
        worksheet["!cols"] = cols;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "NominaPago");
        XLSX.writeFile(workbook, `Nomina_Pagos_${mes || 'SinPeriodo'}.xlsx`);
    };

    const groupHeaders = [
        { title: "Auxiliar", colSpan: 4 },
        { title: "Mes", colSpan: 7, className: "border-left bg-table-celeste" },
        { title: "Anticipo", colSpan: 16, className: "border-left bg-table-amarillo" },
        { title: "Fin de Mes", colSpan: 16, className: "border-left bg-table-verde" },
        { title: "Datos Pago", colSpan: 5, className: "border-left bg-table-naranjo" }
    ];



    const columns = [
        // ⚙️ Acciones (PRIMERA COLUMNA)
        {
            title: "Acciones",
            name: "acciones",
            render: row => (
                <div className="dropdown">
                    <button
                        className="btn btn-sm btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        Acciones
                    </button>

                    <ul className="dropdown-menu">
                        <li>
                            <button
                                className="dropdown-item text-secondary"
                                onClick={() => abrirModal(row)}
                            >
                                <i className="bi bi-person-plus me-2"></i>
                                + Movimiento
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-info"
                                onClick={() => {
                                    setDetalleAuxID(row.auxiliar_id);
                                    setAdelantoAuxID(row.anticipo);
                                    setShowDetalle(true);
                                }}
                            >
                                <i className="bi bi-list-ul me-2"></i>
                                Ver Detalle
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-primary"
                                onClick={() => handleEnviarMail(row)}
                            >
                                <i className="bi bi-envelope me-2"></i>
                                Enviar Mail
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-success"
                                onClick={() => handleEnviarWhatsapp(row)}
                            >
                                <i className="bi bi-whatsapp me-2"></i>
                                Enviar WhatsApp
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-warning"
                                onClick={() => handleNotasSiguientePeriodo(row)}
                            >
                                <i className="bi bi-journal-text me-2"></i>
                                Notas siguiente periodo
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-dark"
                                onClick={() => {
                                    setSelectedResumenRow(row);
                                    setShowResumen(true);
                                }}
                            >
                                <i className="bi bi-file-earmark-spreadsheet me-2"></i>
                                Ver Resumen Pago
                            </button>
                        </li>

                        <li>
                            <button
                                className="dropdown-item text-primary"
                                onClick={() => {
                                    setCalendarioAuxID(row.auxiliar_id);
                                    setShowCalendario(true);
                                }}
                            >
                                <i className="bi bi-calendar3 me-2"></i>
                                Ver Calendario
                            </button>
                        </li>
                    </ul>
                </div>
            ),
            width: 150,
        },

        // 🧾 Identificación
        { title: "RUT", name: "rut", width: 150 },
        {
            title: "Nombre Completo",
            name: "nombre_auxiliar",
            width: 250,
            render: row => (
                <div className="d-flex align-items-center">
                    <span className="text-truncate fw-bold" style={{ maxWidth: 200 }}>
                        {`${row.nombre_auxiliar || ""} ${row.apepat_auxiliar || ""} ${row.apemat_auxiliar || ""}`}
                    </span>
                </div>
            ),
        },
        {
            title: "Pide Anticipo?",
            name: "pide_anticipo",
            width: 100,
            render: row => (row.anticipo == 1 ? "Sí" : "No"),
        },

        // 🧮 Totales del Mes
        {
            title: "Turnos Totales",
            name: "cantidad_turnos_total",
            headerClassName: "border-left",
            cellClassName: "border-left",
            type: "number",
            render: row => `${row.cantidad_turnos_total || 0}`,
            width: 100,
        },
        {
            title: "Total Turnos Bruto",
            name: "valor_turnos_total",
            type: "number",
            render: row => `$${formatMoney(row.valor_turnos_total || 0)}`,
            width: 130,
        },
        {
            title: "Horas Extras Bruto",
            name: "horas_extras_total",
            type: "number",
            render: row => `$${formatMoney(row.horas_extras_total || 0)}`,
            width: 130,
        },
        {
            title: "Horas Extras Liquido",
            name: "horas_extras_total",
            type: "number",
            render: row => `$${formatMoney(row.horas_extras_total * retencionSii || 0)}`,
            width: 130,
        },
        {
            title: "Movilización Total",
            name: "locomocion_total",
            type: "number",
            render: row => `$${formatMoney(row.locomocion_total || 0)}`,
            width: 110,
        },
        {
            title: "Alimentación Total",
            name: "colacion_total",
            type: "number",
            render: row => `$${formatMoney(row.colacion_total || 0)}`,
            width: 110,
        },
        {
            title: "Valor Boleta",
            name: "valor_turnos_total",
            type: "number",
            render: row => `$${formatMoney(row.valor_turnos_total + row.horas_extras_total || 0)}`,
            width: 130,
        },

        // 💸 Adelanto
        {
            title: "Turnos Adelanto",
            name: "cantidad_turnos_adelanto",
            headerClassName: "border-left",
            cellClassName: "border-left",
            type: "number",
            render: row => `${row.cantidad_turnos_adelanto || 0}`,
            width: 100,
        },
        {
            title: "Bruto Adelanto",
            name: "valor_turnos_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.valor_turnos_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Movilización Adelanto",
            name: "locomocion_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.locomocion_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Alimentación Adelanto",
            name: "colacion_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.colacion_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Horas Extras Adelanto",
            name: "horas_extras_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.horas_extras_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Horas Extras Liq Adelanto",
            name: "horas_extras_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.horas_extras_adelanto * retencionSii || 0)}`,
            width: 120,
        },
        {
            title: "Turno + Horas Extra",
            name: "valor_turnos_adelanto",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.valor_turnos_adelanto || 0) +
                        parseFloat(row.horas_extras_adelanto || 0))
                )}`,
            width: 130,
        },
        {
            title: "Líquido Adelanto (14,5%)",
            name: "liquido_adelanto",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.valor_turnos_adelanto || 0) +
                        parseFloat(row.horas_extras_adelanto || 0)) * retencionSii
                )}`,
            width: 130,
        },
        {
            title: "Prestamos",
            name: "prestamos_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.prestamos_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Otros Suma",
            name: "otros_suma_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.otros_suma_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Otros Resta",
            name: "otros_resta_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.otros_resta_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Vacaciones",
            name: "vacaciones_adelanto",
            type: "number",
            render: row => `$${formatMoney(row.vacaciones_adelanto || 0)}`,
            width: 120,
        },
        {
            title: "Notas Adelantos y Prestamos",
            name: "notas_ajustes",
            render: (row) => row.notas_ajustes || "",
            width: 200,
        },
        {
            title: "Líquido Total Adelanto (c/ mov y alim)",
            name: "valor_turnos_adelanto",
            type: "number",
            render: row => {
                const turnosTotal = parseFloat(row.valor_turnos_adelanto || 0);
                const extrasTotal = parseFloat(row.horas_extras_adelanto || 0);
                const movTotal = parseFloat(row.locomocion_adelanto || 0);
                const colTotal = parseFloat(row.colacion_adelanto || 0);

                const liquido = ((turnosTotal + extrasTotal) * retencionSii) + movTotal + colTotal;
                return `$${formatMoney(liquido)}`;
            },
            width: 150,
        },
        {
            title: "Notas Anticipo",
            name: "notas",
            render: row => row.notas_periodo_anticipo || "",
            width: 300,
        },
        {
            title: "Notas Internas Anticipo",
            name: "notas_internas",
            render: row => row.notas_periodo_internas_anticipo || "",
            width: 300,
        },
        // 📊 Fin de Mes (FM = Total - Adelanto)
        {
            title: "Turnos FM",
            name: "turnos_fm",
            headerClassName: "border-left",
            cellClassName: "border-left",
            type: "number",
            render: row =>
                `${(row.cantidad_turnos_total || 0) - (row.cantidad_turnos_adelanto || 0)}`,
            width: 100,
        },
        {
            title: "Bruto FM",
            name: "valor_turnos_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.valor_turnos_total || 0) -
                        parseFloat(row.valor_turnos_adelanto || 0))
                )}`,
            width: 120,
        },
        {
            title: "Líquido FM (14,5%)",
            name: "liquido_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    ((parseFloat(row.valor_turnos_total || 0) -
                        parseFloat(row.valor_turnos_adelanto || 0))) *
                    retencionSii
                )}`,
            width: 130,
        },
        {
            title: "Prestamos",
            name: "prestamos_fm",
            type: "number",
            render: row => `$${formatMoney(row.prestamos_fm || 0)}`,
            width: 120,
        },
        {
            title: "Otros Suma",
            name: "otros_suma_fm",
            type: "number",
            render: row => `$${formatMoney(row.otros_suma_fm || 0)}`,
            width: 120,
        },
        {
            title: "Otros Resta",
            name: "otros_resta_fm",
            type: "number",
            render: row => `$${formatMoney(row.otros_resta_fm || 0)}`,
            width: 120,
        },
        {
            title: "Vacaciones",
            name: "vacaciones_fm",
            type: "number",
            render: row => `$${formatMoney(row.vacaciones_fm || 0)}`,
            width: 120,
        },
        {
            title: "Notas FM y Prestamos",
            name: "notas_ajustes",
            render: (row) => row.notas_ajustes || "",
            width: 200,
        },
        {
            title: "Movilización FM",
            name: "locomocion_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.locomocion_total || 0) -
                        parseFloat(row.locomocion_adelanto || 0))
                )}`,
            width: 120,
        },
        {
            title: "Alimentación FM",
            name: "colacion_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.colacion_total || 0) -
                        parseFloat(row.colacion_adelanto || 0))
                )}`,
            width: 120,
        },
        {
            title: "Horas Extras FM",
            name: "horas_extras_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.horas_extras_total || 0) -
                        parseFloat(row.horas_extras_adelanto || 0))
                )}`,
            width: 120,
        },
        {
            title: "Horas Extras Liq FM",
            name: "horas_extras_fm",
            type: "number",
            render: row =>
                `$${formatMoney(
                    (parseFloat(row.horas_extras_total || 0) -
                        parseFloat(row.horas_extras_adelanto || 0)) * retencionSii
                )}`,
            width: 120,
        },

        // 🧾 Totales combinados y notas
        {
            title: "Líquido Total Mes (c/ mov y alim)",
            name: "liquido_total_mes",
            type: "number",
            render: row => {

                let turnosTotal = parseFloat(row.valor_turnos_adelanto || 0);
                let extrasTotal = parseFloat(row.horas_extras_adelanto || 0);
                let movTotal = parseFloat(row.locomocion_adelanto || 0);
                let colTotal = parseFloat(row.colacion_adelanto || 0);

                let liquidoAnticipo = ((turnosTotal + extrasTotal) * retencionSii) + movTotal + colTotal;

                turnosTotal = parseFloat(row.valor_turnos_total || 0);
                extrasTotal = parseFloat(row.horas_extras_total || 0);
                movTotal = parseFloat(row.locomocion_total || 0);
                colTotal = parseFloat(row.colacion_total || 0);

                let liquido = (turnosTotal + extrasTotal) * retencionSii + movTotal + colTotal - liquidoAnticipo;
                return `$${formatMoney(liquido)}`;
            },
            width: 150,
        },
        {
            title: "Total a Pagar",
            name: "total_a_pagar",
            type: "number",
            render: row => {
                const totalAPagar = calcularTotalAPagar(row);
                return `$${formatMoney(totalAPagar)}`;
            },
            width: 150,
        },
        {
            title: "Notas",
            name: "notas",
            render: row => row.notas_periodo_fm || "",
            width: 300,
        },
        {
            title: "Notas Internas",
            name: "notas_internas",
            render: row => row.notas_periodo_internas_fm || "",
            width: 300,
        },

        // 💳 Datos administrativos
        {
            title: "Datos de Pago",
            name: "datos_pago",
            headerClassName: "border-left",
            cellClassName: "border-left",
            render: row => row.datos_pago || "",
            width: 400,
        },
        {
            title: "Boleta Electrónica",
            name: "datos_sii",
            render: row => row.datos_sii || "",
            width: 200,
        },
    ];

    const handleGenerarLiquidacion = async () => {
        if (!mes) return;
        try {
            gdAlertify.showLoader();
            await axiosInstance.post('/acuerdo-mutuo/cobranza/liquidar', { periodo: mes });
        } catch (error) {
            console.error("Error al generar liquidación:", error);
        } finally {
            gdAlertify.hideLoader();
            navigate('/liquidaciones');
        }
    };

    return (
        <div className="container-fluid mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Honorarios - Fin de Mes</h3>
                    <div className="row g-3 align-items-end">
                        <div className="col-md-4">
                            <label className="form-label">Mes</label>
                            <input
                                type="month"
                                className="form-control"
                                value={mes}
                                onChange={e => setMes(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-primary w-100"
                                onClick={buscarCobranza}
                                disabled={!mes}
                            >
                                <i className="bi bi-search me-2"></i>
                                Buscar
                            </button>
                        </div>
                        <div className="col-md-2">
                            <div className="dropdown w-100">
                                <button
                                    className="btn btn-secondary dropdown-toggle w-100"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    disabled={!mes}
                                >
                                    Acciones
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <button
                                            className="dropdown-item text-success"
                                            onClick={handleExportarNominaPago}
                                            disabled={!resultados.length}
                                        >
                                            <i className="bi bi-file-earmark-excel me-2"></i>
                                            Nómina Pago
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item text-primary"
                                            onClick={handleGenerarLiquidacion}
                                        >
                                            <i className="bi bi-lightning-charge me-2"></i>
                                            Liquidar Fin de Mes
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Indicadores de Estado Global */}
                        <div className="col-md-4">
                            <div className="d-flex align-items-center h-100 mt-2 mt-md-0">
                                <span className="me-2 small fw-bold text-muted">ESTADO:</span>
                                <div className="d-flex gap-2">
                                    <div className={`badge ${periodoStatus.estado_adelanto === 'confirmado' ? 'bg-primary' : 'bg-light text-muted border'} p-2 d-flex align-items-center`}>
                                        <i className={`bi ${periodoStatus.estado_adelanto === 'confirmado' ? 'bi-check-circle-fill' : 'bi-clock'} me-1`}></i>
                                        Adelanto: {periodoStatus.estado_adelanto === 'confirmado' ? 'LIQUIDADO' : 'PENDIENTE'}
                                    </div>
                                    <div className={`badge ${periodoStatus.estado_fm === 'confirmado' ? 'bg-success' : 'bg-light text-muted border'} p-2 d-flex align-items-center`}>
                                        <i className={`bi ${periodoStatus.estado_fm === 'confirmado' ? 'bi-check-circle-fill' : 'bi-clock'} me-1`}></i>
                                        Fin de Mes: {periodoStatus.estado_fm === 'confirmado' ? 'LIQUIDADO' : 'PENDIENTE'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="mt-3">
                        <GdTable
                            columns={columns}
                            data={resultados}
                            groupHeaders={groupHeaders}
                            stickyHeader={true}
                            height={800}
                            showCsvExport={true}
                            initialSort={[0, "asc"]}
                            itemsPerPageOptions={[100, 200, 300, 500, 1000]}
                            defaultItemsPerPage={500}

                        />
                    </div>
                </div>
            </div>
            {modalVisible && (
                <MovimientoModal
                    row={selectedRow}
                    periodo={mes}
                    onClose={cerrarModal}
                    onConfirm={onConfirmMovimiento}
                />
            )}
            <DetalleTurnos
                visible={showDetalle}
                onClose={() => setShowDetalle(false)}
                periodo={mes}
                auxiliarID={detalleAuxID}
                quiereAdelanto={adelantoAuxID}
                modo="fm"        // o "adelanto"
                factorRetencion={retencionSii}
                isLiquidadoAdelanto={resultados.find(r => r.auxiliar_id === detalleAuxID)?.is_liquidado_adelanto}
                isLiquidadoFM={resultados.find(r => r.auxiliar_id === detalleAuxID)?.is_liquidado_fm}
            />

            <CalendarioDetalleAuxiliar
                visible={showCalendario}
                onClose={() => setShowCalendario(false)}
                periodo={mes}
                auxiliarID={calendarioAuxID}
                modo="fm"
                factorRetencion={retencionSii}
            />

            {/* Modal Resumen Pago FM */}
            {showResumen && selectedResumenRow && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Resumen de Pago (Fin de Mes)</h5>
                                <button className="btn-close" onClick={() => setShowResumen(false)}></button>
                            </div>
                            <div className="modal-body bg-light text-dark" id="resumen-pago-container-fm">
                                <ResumenPagoAuxiliar
                                    row={selectedResumenRow}
                                    periodo={mes}
                                    modo="fm"
                                    factorRetencion={retencionSii}
                                    configTextos={configTextos}
                                />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowResumen(false)}>Cerrar</button>
                                <button className="btn btn-info text-white" onClick={handleCopiarImagen}>
                                    <i className="bi bi-clipboard-check me-2"></i>Copiar
                                </button>
                                <button className="btn btn-primary" onClick={() => window.print()}>Imprimir</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Notas Siguiente Periodo */}
            {modalNotasVisible && (
                <ModalNotasPeriodo
                    visible={modalNotasVisible}
                    onClose={() => setModalNotasVisible(false)}
                    row={selectedRowNotas}
                    onSave={guardarNotaSiguientePeriodo}
                />
            )}
        </div>
    );
};

const MovimientoModal = ({ row, periodo, onClose, onConfirm }) => {
    // --- Estado de los valores de cada movimiento (inicializados con datos de fin de mes) ---
    const [montoPrestamo, setMontoPrestamo] = useState(row?.prestamos_fm?.toString() ?? "");
    const [montoOtrosSuma, setMontoOtrosSuma] = useState(row?.otros_suma_fm?.toString() ?? "");
    const [montoOtrosResta, setMontoOtrosResta] = useState(row?.otros_resta_fm?.toString() ?? "");
    const [montoVacaciones, setMontoVacaciones] = useState(row?.vacaciones_fm?.toString() ?? "");

    // --- Estado de una única observación para todos los movimientos ---
    const [observacion, setObservacion] = useState(row?.notas_ajustes_fm ?? "");

    // Cuando cambie la fila (abrir modal con otro auxiliar) actualizamos los estados
    useEffect(() => {
        setMontoPrestamo(row?.prestamos_fm?.toString() ?? "");
        setMontoOtrosSuma(row?.otros_suma_fm?.toString() ?? "");
        setMontoOtrosResta(row?.otros_resta_fm?.toString() ?? "");
        setMontoVacaciones(row?.vacaciones_fm?.toString() ?? "");
        setObservacion(row?.notas_ajustes_fm ?? "");
    }, [row]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Simplified array: solo contiene el valor y el tipo
    const movimientos = [
        { tipo: 1, label: "Descuento Préstamo", value: montoPrestamo, setter: setMontoPrestamo },
        { tipo: 2, label: "Otros Suma", value: montoOtrosSuma, setter: setMontoOtrosSuma },
        { tipo: 3, label: "Otros Resta", value: montoOtrosResta, setter: setMontoOtrosResta },
        { tipo: 4, label: "Vacaciones", value: montoVacaciones, setter: setMontoVacaciones },
    ];

    const handleGuardar = async () => {
        setLoading(true);
        setError(null);

        try {
            const auxiliar_id = row.auxiliar_id || row.id || null;

            const movimientosValidos = movimientos.filter(
                (m) => m.value !== "" && m.value !== null && m.value !== undefined && parseFloat(m.value) >= 0
            );

            if (movimientosValidos.length === 0) {
                setError("Debes ingresar al menos un monto válido.");
                setLoading(false);
                return;
            }

            // Construimos el payload con los valores y una única observación
            const payload = {
                auxiliar_id,
                tipo: "fm", // tipo "fm" para fin de mes
                montoPrestamo,
                montoOtrosSuma,
                montoOtrosResta,
                montoVacaciones,
                observacion,
                periodo, // Usar el periodo pasado como prop
            };

            await axiosInstance.post("/acuerdo-mutuo/ajuste", payload);

            if (onConfirm) onConfirm();
            onClose();
        } catch (err) {
            console.error(err);
            setError("Hubo un error al guardar los movimientos.");
        } finally {
            setLoading(false);
        }
    };

    if (!row) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Agregar Movimientos Fin de Mes - {row.auxiliar}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        {movimientos.map((mov, i) => (
                            <div className="mb-3" key={i}>
                                <label className="form-label">{mov.label}</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Ej: 10000"
                                    value={mov.value}
                                    onChange={(e) => mov.setter(e.target.value)}
                                />
                            </div>
                        ))}
                        {/* Área única de observación para todos los movimientos */}
                        <div className="mb-3">
                            <label className="form-label">Observación General</label>
                            <textarea
                                className="form-control"
                                placeholder="Observación (opcional)"
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                            />
                        </div>
                        {error && <div className="alert alert-danger">{error}</div>}
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
                            Cancelar
                        </button>
                        <button className="btn btn-primary" onClick={handleGuardar} disabled={loading}>
                            {loading ? "Guardando..." : "Guardar Movimientos"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// -----------------------
//  MODAL NOTAS SIGUIENTE PERIODO
// -----------------------
const ModalNotasPeriodo = ({ visible, onClose, row, onSave }) => {
    const [nota, setNota] = useState(row?.notas_siguiente_periodo || "");

    if (!visible) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">Notas siguiente período</h5>
                        <button className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        <label className="form-label">Nota</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            value={nota}
                            onChange={e => setNota(e.target.value)}
                        />
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Cancelar
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={() => onSave(nota)}
                        >
                            Guardar
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Honorarios;
